import React, { useState } from "react";
import "./Popup.css";

const HomePopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: ""
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    const data = {
      access_key: "33758703-84b6-45b7-b677-a2d8023e3622",
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      subject: "New Property Enquiry",
      from_name: "Saptveda venture",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        setStatus("Form is submitted successfully ✅");

        setFormData({
          name: "",
          phone: "",
          email: ""
        });

        // 🔹 Auto-hide message after 5 sec
        setTimeout(() => {
          setStatus("");
          onClose(); // optional: auto close popup
        }, 5000);

      } else {
        setStatus("Submission failed ❌ Please try again.");
      }
    } catch (error) {
      setStatus("Network error ❌ Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={onClose}>✕</button>

        <h2>Get Exclusive Property Details</h2>
        <p>Fill the form & our expert will contact you shortly</p>

        <form className="popup-form" onSubmit={handleSubmit}>
          <input 
            type="text" 
            name="name"
            placeholder="Your Name" 
            value={formData.name}
            onChange={handleChange}
            required 
          />

          <input 
            type="tel" 
            name="phone"
            placeholder="Phone Number" 
            value={formData.phone}
            onChange={handleChange}
            required 
          />

          <input 
            type="email" 
            name="email"
            placeholder="Email Address" 
            value={formData.email}
            onChange={handleChange}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Request Callback"}
          </button>

          {/* Status message */}
          {status && <p className="form-status">{status}</p>}
        </form>
      </div>
    </div>
  );
};

export default HomePopup;
